module.exports = __webpack_public_path__ + "static/media/sq6.9a57e1d9.jpg";